<template>
  <v-dialog
    v-model="dialog"
    persistent
    scrollable
    max-width="800px"
  >
    <v-card :loading="loading">
      <v-card-title>
        <span v-if="item.id">Cập nhật dữ liệu</span>
        <span v-else>Thêm mới</span>
        <v-spacer/>
        <v-menu
          bottom
          left
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              @click="close()"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </template>
        </v-menu>
      </v-card-title>
      <v-card-text>
        <v-container>
          <div v-if="errors_exist" class="row">
            <div class="col">
              <v-alert
                dense
                outlined
                type="error"
              >
                {{ $vuetify.lang.t('$vuetify.msg.hasError') }}
                <ul>
                  <div v-for="(error, index) in errors">
                    <li :key="index">{{ error[0] }}</li>
                  </div>
                </ul>
              </v-alert>
            </div>
          </div>
          <v-row>
            <v-col cols="12">
              <input 
                type="file" 
                @change="onFilePicked" 
                class="d-none" 
                ref="fileInput" 
                accept="image/*"
              />
              <v-hover v-slot="{ hover }">
                <v-img
                  v-if="logo_url"
                  :src="logo_url"
                  class="mx-auto elevation-1"
                  @click="onPickFile"
                  width="150"
                >
                  <div v-if="hover" class="avatar-icon-upload">
                    <v-icon large color="yellow">mdi-tray-arrow-up</v-icon>
                  </div>
                </v-img>
                <v-img
                  v-else
                  src="@/assets/NoImage.jpg"
                  class="mx-auto elevation-1"
                  @click="onPickFile"
                  width="150"
                >
                  <div v-if="hover" class="avatar-icon-upload">
                    <v-icon large color="yellow">mdi-tray-arrow-up</v-icon>
                  </div>
                </v-img>
              </v-hover>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="item.san_pham"
                label="Sản phẩm"
                class="require"
                autofocus
                hide-details
              />
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="item.co_so"
                label="Cơ sở được cấp giấy xác nhận chuỗi"
                class="require"
                hide-details
              />
            </v-col>
            <v-col cols="12">
              <v-select
                v-model="areaSelected"
                :items="areas"
                item-text="name"
                item-value="maqh"
                label="Vùng nguyên liệu"
                class="require"
                return-object
                hide-details
              />
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="item.dia_chi"
                label="Địa chỉ"
                class="require"
                hide-details
              />
            </v-col>
            <v-col
              cols="12"
              sm="6"
              md="6"
            >
              <v-text-field
                v-model="item.dien_thoai"
                label="Điện thoại"
                class="require"
                hide-details
              />
            </v-col>
            <v-col
              cols="12"
              sm="6"
              md="6"
            >
              <v-text-field
                v-model="item.quy_mo"
                label="Quy mô/Sản lượng chuỗi"
                hide-details
              />
            </v-col>
            <v-col cols="12">
              <label>Mô tả sản phẩm</label>
              <quill-editor 
                v-model="item.mo_ta"
                style="min-height:150px;"
                :options="editorOption"
              >
              </quill-editor>
            </v-col>
            <v-col cols="12">
              <label>Hình ảnh sản phẩm</label>
              <vue-dropzone 
                ref="pictureDropzone" 
                id="dropzone" 
                :options="dropzoneOptions"
                :destroyDropzone="false"
                v-on:vdropzone-success="uploadSuccess"
                v-on:vdropzone-error="uploadError"
                v-on:vdropzone-removed-file="fileRemoved"
                @vdropzone-mounted="loadPictures"
              />
            </v-col>
            <v-col cols="12">
              <label>Giấy chứng nhận (nếu có)</label>
              <vue-dropzone 
                ref="certDropzone" 
                id="certDropzone" 
                :options="dropzoneOptions"
                :destroyDropzone="false"
                v-on:vdropzone-success="certUploadSuccess"
                v-on:vdropzone-error="certUploadError"
                v-on:vdropzone-removed-file="certFileRemoved"
                @vdropzone-mounted="certLoadPictures"
              />
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <small><span class="pink--text">(*)</span> bắt buộc nhập</small>
        <v-spacer/>
        <v-btn
          color="pink darken-1"
          text
          @click="close"
        >
          Hủy bỏ
        </v-btn>
        <v-btn
          color="primary darken-1"
          text
          @click="save(item)"
        >
          Lưu lại
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
  import vue2Dropzone from 'vue2-dropzone';
  import 'vue2-dropzone/dist/vue2Dropzone.min.css';
  import { mapActions, mapState } from 'vuex';
  export default {
    components: { 
      vueDropzone: vue2Dropzone
    },
    props: {
      showDialog: {
        type: Boolean,
        default: false
      },
      item: {
        type: Object
      }
    },
    data () {
      return {
        loading: false,
        dialog: false,
        logo_url: null,
        errors_exist: false,
        errors: [],
        areas: [],
        areaSelected: null,
        dropzoneOptions: {
          url: null,
          addRemoveLinks: true,
          dictRemoveFile: "×",
          removeType: "server",
          dictDefaultMessage: "<i class='mdi mdi-24px mdi-arrow-collapse-up'></i> <div>Tải lên hình ảnh</div>",
          acceptedFiles: "image/jpeg,image/png,image/jpg",
          thumbnailWidth: 100,
          thumbnailHeight: 100,
          headers: {
            "Authorization": `Bearer ${JSON.parse(localStorage.getItem('user')).token}`,
            "Cache-Control": null, 
            "X-Requested-With": null
          },
        },
        editorOption: {
          placeholder: 'Nhập văn bản ở đây',
        },
        certs: [],
        images: [],
        invalidIds: []
      }
    },
    computed: {
      ...mapState([ 
        'config'
      ])
    },
    mounted() {
      this.dialog = this.showDialog;
      this.dropzoneOptions.url = `${this.config.beUrl}/api/v1/images`;
      this.getAreas();
    },
    watch: {
      showDialog() {
        this.dialog = false;
        this.errors_exist=false;
        if (this.showDialog) {
          this.dialog = true;
          this.logo_url = null;
          if(this.item.logo) {
            this.logo_url = `${this.config.beUrl}/uploads/${this.item.logo}`;
          }
          this.areaSelected = this.areas.find(
            element => element.maqh == this.item.khu_vuc_id
          );
          this.loadPictures();
          this.certLoadPictures();
        }
      }
    },
    methods: {
      ...mapActions([
        'openSnackbar'
      ]),
      getAreas () {
        axios.get("api/v1/get-district-by-province")
          .then(response => {
            this.areas = response.data;
          })
          .catch(function (error) {
            console.log(error);
          });
      },
      close() {
        this.dialog = false;
        this.$emit('cancelled');
      },
      save(item) {
        const app = this;
        let method = "post";
        let url = `api/v1/product-chains`;
        let data = item; 

        if(app.areaSelected){
          data.khu_vuc_id = app.areaSelected.maqh;
        }

        data.certs = app.certs;
        data.images = app.images.filter(e => !app.invalidIds.includes(e.id));
        
        if (data.id) {
          method = "patch";
          url = `api/v1/product-chains/${data.id}`;
        }

        app.loading=true;

        axios[method](url, data)
          .then((response) => {
            if (response.data && response.data.id) {
              app.$emit('confirmed', response.data);
            }
            app.loading=false;
          }).catch(function (error) {
            app.loading=false;
            app.errors_exist = true;
            if(error.response.status === 422) {
              app.errors = error.response.data || {};
            }
          });
      },
      onPickFile () {
        this.$refs.fileInput.value=null;
        this.$refs.fileInput.click();
      },
      onFilePicked (event) {
        const app = this;

        const file = event.target.files[0];
        app.logo_url = URL.createObjectURL(file);

        const config = {
          headers: { 'content-type': 'multipart/form-data' }
        };

        let formData = new FormData();
        formData.append('file', file);

        axios.post('api/v1/images', formData, config)
          .then(function (response) {
            app.item.logo = response.data.filePath;
            app.openSnackbar({ type: 'success' });
          })
          .catch(function (error) {
            app.logo = null;
            app.openSnackbar({ type: 'error' });
          });
      },
      // CERT UPLOAD
      certUploadSuccess(file, response) {
        this.openSnackbar({ 
          type: 'success',
          body: 'Tải giấy chứng nhận lên thành công!'
        });
        file.previewElement.querySelector("[data-dz-name]").innerHTML = response.filePath;
        this.certs.push(response.fileId);
      },
      certUploadError(file, message) {
        this.openSnackbar({ type: 'error' });
      },
      certFileRemoved(file, error, xhr) {
        const app = this;
        if(app.dropzoneOptions.removeType == "server") {
          axios.post('api/v1/remove-product-chain-cert-img', {
            id: app.item.id,
            fileName: file.previewElement.querySelector("[data-dz-name]").innerHTML
          })
            .then(function (response) {
              file.previewElement.remove();
              app.invalidIds.push(response.data);
              app.openSnackbar({ 
                type: 'success',
                body: 'Xóa giấy chứng nhận thành công!'
              });
            })
            .catch(function (error) {
              app.openSnackbar({ type: 'error' });
            });
        } else {
          file.previewElement.remove();
        }
      },
      certLoadPictures() {
        if(this.$refs.certDropzone){
          this.dropzoneOptions.removeType = "client"; // để làm rỗng danh sách image trước khi load, 
          // remove file nếu không đặt client trước thì nó xóa luôn trên server.
          this.$refs.certDropzone.removeAllFiles();
          // sau khi làm rỗng danh sách gcn, 
          // đặt lại type là server để nếu có xóa thì biết là xóa trên server
          this.dropzoneOptions.removeType = "server";
        }
        // sau khi xóa xong, load file lên.
        this.item.cert_images.forEach(image => {
          if(!this.invalidIds.includes(image.id)) {
            var file = { size: 123, name: image.path, type: "image/png" };
            var url = `${this.config.beUrl}/uploads/${image.path}`;
            if(this.$refs.certDropzone){
              this.$refs.certDropzone.manuallyAddFile(file, url);
            }
          }
        });
      },
      // PHOTO UPLOAD
      uploadSuccess(file, response) {
        this.openSnackbar({ 
          type: 'success',
          body: 'Tải giấy chứng nhận lên thành công!'
        });
        file.previewElement.querySelector("[data-dz-name]").innerHTML = response.filePath;
        this.images.push(response.fileId);
      },
      uploadError(file, message) {
        this.openSnackbar({ type: 'error' });
      },
      fileRemoved(file, error, xhr) {
        const app = this;
        if(app.dropzoneOptions.removeType == "server") {
          axios.post('api/v1/remove-product-chain-img', {
            id: app.item.id,
            fileName: file.previewElement.querySelector("[data-dz-name]").innerHTML
          })
            .then(function (response) {
              file.previewElement.remove();
              app.invalidIds.push(response.data);
              app.openSnackbar({ 
                type: 'success',
                body: 'Xóa giấy chứng nhận thành công!'
              });
            })
            .catch(function (error) {
              app.openSnackbar({ type: 'error' });
            });
        } else {
          file.previewElement.remove();
        }
      },
      loadPictures() {
        if(this.$refs.pictureDropzone){
          this.dropzoneOptions.removeType = "client";
          this.$refs.pictureDropzone.removeAllFiles();
          this.dropzoneOptions.removeType = "server";
        }
        this.item.images.forEach(image => {
          if(!this.invalidIds.includes(image.id)) {
            var file = { size: 123, name: image.path, type: "image/png" };
            var url = `${this.config.beUrl}/uploads/${image.path}`;
            if(this.$refs.pictureDropzone){
              this.$refs.pictureDropzone.manuallyAddFile(file, url);
            }
          }
        });
      },
    }
  }
</script>
<style>
  .dz-remove{
    background: red !important;
    display:inline-block !important;
    width:25px !important;
    height:25px !important;
    padding: 3px 8px !important;
    position:absolute;
    top:5px !important;
    right:5px;
    z-index:1000;
    font-size:1.2em !important;
    line-height:1em;
    text-align:center;
    font-weight:bold;
    border:1px solid gray !important;
    border-radius:1.2em;
    color:gray;
    background-color:white;
    opacity:.5;   
  }

  .dz-remove:hover{
    text-decoration:none !important;
    opacity:1;
  }
  .avatar-icon-upload{
    position: absolute;
    background: gray;
    width: 100%;
    height: 100%;
    opacity: 0.7;
    cursor: pointer;
  }
  .avatar-icon-upload .v-icon{
    font-size: 36px;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
  }
</style>